import * as sidebar from "../../sidebar/index";
import 'lib/soon-countdown';

export function init() {
	const $list = $('#contestsList');

	sidebar.init({
		heightTarget: $list
	});

	$list.zInfiniteScroll({
		selector: '[rel=page]',
		loading: '#pagesScrollLoader',
		maxAutoloadPages: 200,
		totalCount: $list.data('totalCount'),
		fetch: (page, callback) => {
			const data = {
				page: page,
				type: $list.data('blogType'),
				category: $list.data('blogCategory'),
			};
			$.get($list.data('loadUrl'), data, null, 'json')
				.done(response => {
					const $blocks = $(response['html']).filter('[rel=page]');
					callback($blocks);
				});
		}
	});
}



// WEBPACK FOOTER //
// ./modules/blog/list/contest/index.js